import { alpha } from "@mui/material";

// MAIN
export const PRIMARY_COLOR = "#039";
export const PRIMARY_LIGHT = "#f3f5fb";
export const PRIMARY_DARK = "#041643";
export const SECONDARY_COLOR = "#041643";
export const DIM_COLOR = "#8695bd";

// SHADES
export const primary5 = alpha(PRIMARY_COLOR, 0.05);
export const primary10 = alpha(PRIMARY_COLOR, 0.1);
export const primary20 = alpha(PRIMARY_COLOR, 0.2);
export const primary50 = alpha(PRIMARY_COLOR, 0.5);
export const primary80 = alpha(PRIMARY_COLOR, 0.8);

// OTHERS
export const INFO_YELLOW = "#835700";
export const INFO_RED = "#b91c1c";
